// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation-module--nav--2o1Fv","item":"navigation-module--item--1ogZe"};